module.exports = __webpack_public_path__ + "img/intercomdescribe1.f9e3a28b.png";